module.exports = __webpack_public_path__ + "img/easy-approval.ee6d907d.jpg";